import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const SearchParticipant = ({ label, eventId, teamName, eventType }) => {
  const [firstName, setFirstName] = useState(''),
    [lastName, setLastName] = useState('');

  const handleSearch = e => {
    e.preventDefault();

    const firstNameSearch = firstName ? encodeURIComponent(firstName) : encodeURIComponent('%%%');
    const lastNameSearch = lastName ? encodeURIComponent(lastName) : encodeURIComponent('%%%');
    const teamNameSearch = encodeURIComponent(teamName);

    if (teamName) {
      window.location = `SPageServer?pagename=${eventType}_search&eventId=${eventId}&searchType=participant&firstName=${firstNameSearch}&lastName=${lastNameSearch}&groupName=${teamNameSearch}`;
    } else {
      window.location = `SPageServer?pagename=${eventType}_search&eventId=${eventId}&searchType=participant&firstName=${firstNameSearch}&lastName=${lastNameSearch}`;
    }
  };

  return (
    <form className="global-leaderboard-search" onSubmit={handleSearch}>
      <div className="columns">
        <div className="column is-one-third">
          <div className="columns mb-2">
            <div className="column pb-0 is-full">
              <label aria-label="label" className="control">
                {label}
              </label>
            </div>
          </div>
          <div className="columns is-gapless">
            <div className="column mr-1 mb-4">
              <input aria-label="first name" className="input" type="text" onChange={event => setFirstName(event.target.value)} placeholder="First name" />
            </div>
            <div className="column mr-1 mb-4">
              <input aria-label="last name" className="input" type="text" placeholder="Last name" onChange={event => setLastName(event.target.value)} />
            </div>
            <div className="column is-narrow is-hidden-mobile">
              <button className="control button is-search is-hidden-mobile" type="submit">
                <span className="is-sr-only">Search</span>
              </button>
            </div>
            <div className="column is-hidden-tablet">
              <button className="control button is-search" type="submit">
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

SearchParticipant.propTypes = {
  eventId: PropTypes.string,
  eventType: PropTypes.string,
  label: PropTypes.string,
  searchType: PropTypes.string,
  teamName: PropTypes.string,
};

export default SearchParticipant;
